import { GetDocumentVersionMetadataRequest, CpsDocumentMetadata } from '@cs-cms/types';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { versionsQueryKeys } from '../../queryKeys/versions';

export function useGetDocumentVersionMetadata(
  dto: GetDocumentVersionMetadataRequest,
  options?: Partial<UseQueryOptions<{ metadata: CpsDocumentMetadata }, unknown>>
): UseQueryResult<{ metadata: CpsDocumentMetadata }, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDocumentVersionMetadata = () => {
    if (servicesCtx?.versionsService) {
      return servicesCtx.versionsService.getVersionMetadata(dto);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: versionsQueryKeys.getVersionMetadata(dto),
    queryFn: getDocumentVersionMetadata,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: dto.versionId.length > 0,
    ...options
  });
}
